(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  // Verified submission dates for the reviews featured in this carousel.
  const mcFeaturedReviewDates = {
    "777d4dc7-9e30-4482-ae22-eb5736162eef": "2026-03-02",
    "a7eaaab2-6c0c-4bfd-91aa-eea5655d3172": "2026-02-26",
    "7c999852-2eb7-4164-9cd5-9f7716d1096c": "2026-02-26",
    "7531b93b-99a3-4002-9ccf-9ef3528d6276": "2026-02-20",
    "8a7811cc-8b40-4fd2-a2ad-199f80087b1c": "2026-06-04",
    "3ffd0323-7946-425c-9a9c-a5778d999843": "2026-05-27",
    "1bad7457-e8ec-4442-bf09-45c5d3c3567c": "2026-05-18",
    "2a6b4964-0921-4024-85a4-25a9cbd6b79b": "2026-05-11",
    "a3ae8fb9-a6cd-4cf0-a7aa-d0d87f7121f4": "2026-03-10",
    "ec27f789-7a6a-4f14-9775-af0280fc5613": "2026-03-10",
    "f81cf191-1d33-4786-89a3-1741b1b39ec3": "2026-03-10",
    "07830227-8e90-4190-a2c0-cb978b177c61": "2026-03-04"
  };
  const mcReviewDateFormatter = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {
    dateStyle: 'medium',
    timeZone: 'UTC'
  });

  function initReviewCardScale(section) {
    const carousel = section.querySelector('.mc-customer-reviews__carousel');
    if (!carousel || carousel.dataset.mcCardScaleReady) return;
    carousel.dataset.mcCardScaleReady = 'true';

    let drag;
    let suppressClick = false;

    carousel.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      suppressClick = false;
      const widget = event.target.closest('.jdgm-cards-carousel');
      if (!widget || !event.target.closest('.jdgm-cards-wrapper')) return;
      drag = { id: event.pointerId, x: event.clientX, y: event.clientY, widget };
      event.preventDefault();
    });

    carousel.addEventListener('dragstart', (event) => {
      if (drag) event.preventDefault();
    });

    carousel.addEventListener('pointermove', (event) => {
      if (drag?.id !== event.pointerId) return;
      const x = Math.abs(event.clientX - drag.x);
      const y = Math.abs(event.clientY - drag.y);
      if (!suppressClick && x > 8 && x > y) {
        carousel.setPointerCapture(event.pointerId);
        suppressClick = true;
        carousel.setAttribute('data-mc-dragging', '');
      }
    });

    function finishDrag(event) {
      if (drag?.id !== event.pointerId) return;
      const { widget, x, y } = drag;
      drag = null;
      carousel.removeAttribute('data-mc-dragging');
      if (event.type !== 'pointerup' || !suppressClick) return;

      const distance = event.clientX - x;
      if (Math.abs(distance) < 32 || Math.abs(distance) < Math.abs(event.clientY - y)) return;
      const arrows = widget.querySelectorAll('.jdgm-arrow');
      if (arrows.length !== 2) return;
      const rtl = getComputedStyle(widget).direction === 'rtl';
      arrows[(distance < 0) !== rtl ? 1 : 0].click();
    }

    carousel.addEventListener('pointerleave', () => {
      if (!suppressClick) drag = null;
    });
    carousel.addEventListener('pointerup', finishDrag);
    carousel.addEventListener('pointercancel', finishDrag);
    carousel.addEventListener('lostpointercapture', finishDrag);
    carousel.addEventListener('click', (event) => {
      if (!suppressClick || !event.detail) return;
      suppressClick = false;
      event.preventDefault();
      event.stopPropagation();
    }, true);

    function wrapCards() {
      carousel.querySelectorAll('.jdgm-card').forEach((card) => {
        if (card.querySelector('.mc-customer-reviews__card-inner')) return;
        const inner = document.createElement('div');
        inner.className = 'mc-customer-reviews__card-inner';
        while (card.firstChild) inner.appendChild(card.firstChild);
        card.appendChild(inner);

        const date = mcFeaturedReviewDates[card.dataset.reviewId];
        const reviewer = inner.querySelector('.jdgm-reviewer-info');
        if (date && reviewer) {
          const time = document.createElement('time');
          time.className = 'mc-customer-reviews__date';
          time.dateTime = date;
          time.textContent = mcReviewDateFormatter.format(new Date(date));
          reviewer.appendChild(time);
        }
      });
    }

    const observer = new MutationObserver(wrapCards);
    observer.observe(carousel, { childList: true, subtree: true });
    wrapCards();

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(carousel)) observer.disconnect();
    });
  }

  document.querySelectorAll('.mc-customer-reviews').forEach(initReviewCardScale);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.mc-customer-reviews').forEach(initReviewCardScale);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-engraving-designs"] && !Shopify.designMode) return;
  try {
    
  if ('IntersectionObserver' in window && window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
    const cards = new WeakMap();
    const variantFiles = new Map();
    const getVariants = (url) => {
      if (!variantFiles.has(url)) {
        variantFiles.set(url, fetch(url).then(response => {
          if (!response.ok) throw new Error('Engraving variants unavailable');
          return response.json();
        }).catch(() => {
          variantFiles.delete(url);
          return null;
        }));
      }
      return variantFiles.get(url);
    };
    const traceEngraving = (art, state) => {
      const trace = art.querySelector('.mc-eg__engraving-trace');
      const laser = art.querySelector('.mc-eg__laser');
      const bounds = trace.getBBox();
      let start;
      const passes = Math.max(1, Math.ceil(bounds.height / 5));
      trace.style.clipPath = 'inset(0 0 100% 0) fill-box';
      art.classList.remove('is-pending');
      laser.setAttribute('cx', bounds.x);
      laser.setAttribute('cy', bounds.y);
      art.classList.add('is-engraving');

      const draw = (now) => {
        if (!art.isConnected) return;
        start ??= now;
        const progress = Math.min(1, (now - start) / 2600);
        if (progress < 1) {
          const scan = progress * passes;
          const pass = Math.floor(scan);
          const fraction = scan - pass;
          const reverse = pass % 2 === 1;
          const x = (reverse ? 1 - fraction : fraction) * 100;
          const top = pass * 100 / passes;
          const bottom = (pass + 1) * 100 / passes;
          const edge = reverse ? 100 : 0;
          trace.style.clipPath = `polygon(0 0, 100% 0, 100% ${top}%, ${Math.max(edge, x)}% ${top}%, ${Math.max(edge, x)}% ${bottom}%, ${Math.min(edge, x)}% ${bottom}%, ${Math.min(edge, x)}% ${top}%, 0 ${top}%) fill-box`;
          laser.setAttribute('cx', bounds.x + bounds.width * x / 100);
          laser.setAttribute('cy', bounds.y + bounds.height * (top + bottom) / 200);
          state.frame = requestAnimationFrame(draw);
        } else {
          trace.style.removeProperty('clip-path');
          state.frame = 0;
          queueReplay(art, state);
          art.classList.remove('is-engraving');
        }
      };
      state.frame = requestAnimationFrame(draw);
    };

    const queueReplay = (art, state, delay = 3600) => {
      clearTimeout(state.timer);
      if (state.visible && !state.loading) {
        state.timer = setTimeout(() => replay(art, state), delay);
      }
    };
    const replay = async (art, state) => {
      if (!state.visible || !art.isConnected || state.frame || state.loading) return;
      if (document.hidden) {
        queueReplay(art, state);
        return;
      }
      clearTimeout(state.timer);
      const next = (state.variant + 1) % 3;
      if (next > 0) {
        state.loading = true;
        const variants = await getVariants(state.urls[next - 1]);
        state.loading = false;
        if (!state.visible || !art.isConnected) return;
        const outline = variants?.[art.dataset.engravingProduct];
        if (typeof outline !== 'string') return;
        state.path.setAttribute('d', outline);
      } else {
        state.path.setAttribute('d', state.original);
      }
      state.variant = next;
      traceEngraving(art, state);
    };

    const engravingObserver = new IntersectionObserver((entries) => {
      let entering = 0;
      for (const entry of entries) {
        const art = entry.target;
        const state = cards.get(art);
        state.visible = entry.intersectionRatio >= 0.45;
        if (state.visible) {
          const stagger = entering++ * 450;
          queueReplay(art, state, (state.variant === -1 ? 0 : 3600) + stagger);
        } else {
          clearTimeout(state.timer);
          cancelAnimationFrame(state.frame);
          state.frame = 0;
          art.querySelector('.mc-eg__engraving-trace').style.removeProperty('clip-path');
          art.classList.remove('is-engraving');
        }
      }
    }, { threshold: 0.45 });

    const observeEngravings = (scope) => {
      scope.querySelectorAll('.mc-eg__engraving').forEach((art) => {
        if (cards.has(art)) return;
        const path = art.querySelector('.mc-eg__engraving-trace path');
        const { variantOne, variantTwo } = art.closest('mc-engraving-designs').dataset;
        const state = {
          path, original: path.getAttribute('d'), urls: [variantOne, variantTwo],
          variant: -1, visible: false, loading: false, frame: 0, timer: 0,
        };
        cards.set(art, state);
        art.classList.add('is-pending');
        engravingObserver.observe(art);
        art.closest('.mc-eg__feature-link').addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse' && !event.buttons) replay(art, state);
        });
      });
    };
    observeEngravings(document);
    document.addEventListener('shopify:section:load', (event) => observeEngravings(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.mc-eg__engraving').forEach((art) => {
        const state = cards.get(art);
        if (state) {
          state.visible = false;
          clearTimeout(state.timer);
          cancelAnimationFrame(state.frame);
        }
        engravingObserver.unobserve(art);
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-world-map"] && !Shopify.designMode) return;
  try {
    
  if ('IntersectionObserver' in window) {
    const worldMapObserver = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        target.toggleAttribute('data-in-view', isIntersecting);
        if (isIntersecting) target.setAttribute('data-started', '');
      });
    });
    const observeWorldMaps = (scope) => scope.querySelectorAll('.mc-world-map[data-animate="true"]').forEach((map) => {
      worldMapObserver.observe(map);
      const pause = map.querySelector('.mc-world-map__pause');
      pause.hidden = false;
      pause.addEventListener('click', () => {
        const paused = map.toggleAttribute('data-paused');
        pause.setAttribute('aria-pressed', String(paused));
        pause.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
      });
      const lastDrop = map.querySelector('.mc-world-map__drops > g:last-child .mc-world-map__drop');
      lastDrop.addEventListener('animationend', () => {
        if (document.activeElement !== pause) pause.hidden = true;
        else pause.addEventListener('blur', () => { pause.hidden = true; }, { once: true });
      }, { once: true });
    });
    observeWorldMaps(document);
    document.addEventListener('shopify:section:load', (event) => observeWorldMaps(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.mc-world-map').forEach((map) => worldMapObserver.unobserve(map));
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc_collections_signature"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mc-collections-signature')) {
    customElements.define('mc-collections-signature', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('.mc-cs__track');
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.slides = Array.from(this.track.children);
        this.filters = Array.from(this.querySelectorAll('[data-filter]'));
        this.filterList = this.querySelector('.mc-cs__filters');
        this.filterBar = this.querySelector('.mc-cs__filter-bar');
        this.navigation = this.querySelector('.mc-cs__navigation');
        this.visibleSlides = this.slides;
        this.track.dataset.count = String(this.visibleSlides.length);
        this.thumb = this.querySelector('[data-scroll-thumb]');
        this.live = this.querySelector('[data-live]');
        this.index = 0;
        this.positions = [];
        this.suppressClick = false;
        this.measure();
        this.querySelector('.mc-cs__filters').hidden = false;
        this.filters.forEach(button => button.addEventListener('click', () => this.setFilter(button), options));
        this.previous.addEventListener('click', () => this.advanceFilter(-1), options);
        this.next.addEventListener('click', () => this.advanceFilter(1), options);
        this.track.addEventListener('scroll', () => {
          if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => { this.update(); this.announce(); }, 160);
        }, { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.advance(event.key === 'ArrowRight' ? 1 : -1); }
          else if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); this.goTo(event.key === 'Home' ? 0 : this.positions.length - 1); }
        }, options);
        this.track.addEventListener('pointerdown', event => { if (event.pointerType === 'mouse' && event.button === 0) this.drag = { id: event.pointerId, x: event.clientX, left: this.track.scrollLeft, moved: false }; }, options);
        this.track.addEventListener('pointermove', event => {
          if (!this.drag || this.drag.id !== event.pointerId) return;
          const distance = event.clientX - this.drag.x;
          if (!this.drag.moved && Math.abs(distance) > 6) { this.drag.moved = true; this.track.setAttribute('data-dragging', ''); this.track.setPointerCapture(event.pointerId); }
          if (this.drag.moved) { event.preventDefault(); this.track.scrollLeft = this.drag.left - distance; }
        }, options);
        const endDrag = event => {
          if (!this.drag || this.drag.id !== event.pointerId) return;
          const moved = this.drag.moved;
          this.drag = null;
          if (moved) { this.suppressClick = true; this.track.removeAttribute('data-dragging'); this.update(); this.goTo(this.index); clearTimeout(this.clickTimer); this.clickTimer = setTimeout(() => { this.suppressClick = false; }, 250); }
        };
        this.track.addEventListener('pointerup', endDrag, options);
        this.track.addEventListener('pointercancel', endDrag, options);
        this.track.addEventListener('click', event => { if (this.suppressClick) { event.preventDefault(); event.stopPropagation(); } }, { ...options, capture: true });
        this.track.addEventListener('dragstart', event => event.preventDefault(), options);
        this.observer = new ResizeObserver(() => { this.measure(); this.goTo(this.index, false); });
        this.observer.observe(this.track);
        this.filterObserver = new ResizeObserver(() => this.updateFilterNavigation());
        [this.filterBar, ...this.filters].forEach(element => this.filterObserver.observe(element));
        this.addEventListener('shopify:block:select', event => { const slide = event.target.closest('.mc-cs__slide'); if (slide) { this.setFilter(this.filters[0]); this.goTo(this.visibleSlides.indexOf(slide), false); } }, options);
        this.setAttribute('data-ready', '');
        this.updateFilterNavigation();
      }
      updateFilterNavigation() {
        const gap = parseFloat(getComputedStyle(this.filterList).columnGap) || 0;
        const width = this.filters.reduce((total, button) => total + button.getBoundingClientRect().width, 0) + gap * Math.max(0, this.filters.length - 1);
        const fits = width <= this.filterBar.clientWidth + 1;
        this.filterBar.toggleAttribute('data-filters-fit', fits);
        this.navigation.hidden = fits;
      }
      measure() {
        const left = this.track.getBoundingClientRect().left;
        this.visibleSlides = this.slides.filter(slide => !slide.hidden);
        this.positions = this.visibleSlides.map(slide => slide.getBoundingClientRect().left - left + this.track.scrollLeft);
        this.update();
      }
      setFilter(button) {
        this.filters.forEach(filter => filter.setAttribute('aria-pressed', String(filter === button)));
        this.slides.forEach(slide => { slide.hidden = button.dataset.filter !== 'all' && slide.dataset.category !== button.dataset.filter; });
        this.track.scrollTo({ left:0, behavior:'instant' });
        this.index = 0;
        this.measure();
        this.track.dataset.count = String(this.visibleSlides.length);
        this.measure();
        this.announce();
        const filters = button.parentElement;
        const bounds = filters.getBoundingClientRect();
        const buttonBounds = button.getBoundingClientRect();
        if (buttonBounds.left < bounds.left) filters.scrollLeft += buttonBounds.left - bounds.left;
        else if (buttonBounds.right > bounds.right) filters.scrollLeft += buttonBounds.right - bounds.right;
      }
      announce() {
        const category = this.filters.find(filter => filter.getAttribute('aria-pressed') === 'true');
        const position = this.dataset.position.replace('__CURRENT__', String(this.visibleSlides.length ? this.index + 1 : 0)).replace('__TOTAL__', String(this.visibleSlides.length));
        this.live.textContent = category.textContent + ': ' + position;
      }
      update() {
        const left = this.track.scrollLeft;
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.index = this.positions.reduce((best, value, index) => Math.abs(value - left) < Math.abs(this.positions[best] - left) ? index : best, 0);
        const selected = this.filters.findIndex(filter => filter.getAttribute('aria-pressed') === 'true');
        this.previous.disabled = selected <= 0;
        this.next.disabled = selected >= this.filters.length - 1;
        const fraction = this.track.clientWidth / Math.max(this.track.clientWidth, this.track.scrollWidth);
        this.thumb.style.width = `${fraction * 100}%`;
        this.thumb.style.insetInlineStart = `${max ? left / max * (1 - fraction) * 100 : 0}%`;
      }
      goTo(index, smooth = true) {
        const target = this.positions[Math.max(0, Math.min(this.positions.length - 1, index))] || 0;
        this.track.scrollTo({ left: Math.max(0, Math.min(this.track.scrollWidth - this.track.clientWidth, target)), behavior: smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant' });
      }
      advance(direction) {
        this.update();
        const count = Math.max(1, Math.floor(Number.parseFloat(getComputedStyle(this.track).getPropertyValue('--mc-cs-columns')) || 1));
        this.goTo(this.index + direction * count);
      }
      advanceFilter(direction) {
        const selected = this.filters.findIndex(filter => filter.getAttribute('aria-pressed') === 'true');
        const button = this.filters[selected + direction];
        if (button) this.setFilter(button);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.filterObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        clearTimeout(this.settleTimer);
        clearTimeout(this.clickTimer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
